export default __webpack_public_path__ + "static/media/POPPINS-MEDIUMITALIC.ff3f9ef3.TTF";